import { useEffect } from 'react';
import SEO_CONFIG from '../Config/seoConfig';

// Performance optimization hook for SEO
export const usePerformanceOptimization = () => {
  useEffect(() => {

    // Add performance observer for Core Web Vitals (log only in dev/preview)
    if ('PerformanceObserver' in window) {
      const shouldLogVitals = SEO_CONFIG.isDevelopment() || SEO_CONFIG.isPreview();
      
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          if (!shouldLogVitals) return;
          if (entry.entryType === 'largest-contentful-paint') {
            console.log('LCP:', entry.startTime);
          }
          if (entry.entryType === 'first-input') {
            console.log('FID:', entry.processingStart - entry.startTime);
          }
          if (entry.entryType === 'layout-shift') {
            // Only log significant unexpected layout shifts (> 0.1)
            // Exclude small shifts that might be from intended animations
            if (!entry.hadRecentInput && entry.value > 0.1) {
              console.log('CLS (significant):', entry.value);
            }
          }
        });
      });
      observer.observe({ entryTypes: ['largest-contentful-paint', 'first-input', 'layout-shift'] });
    }

    // Optimize loading for better SEO scores
    if ('requestIdleCallback' in window) {
      requestIdleCallback(() => {
        // Load non-critical resources during idle time
        import('../Data/wisdomQuotes.js');
      });
    }

    // Service worker disabled for SPA - not beneficial for single-page modal navigation
    // Static assets are already optimally cached by browser + Vercel CDN
    // Uncomment below if you add multi-page routing or offline functionality:
    /*
    if (SEO_CONFIG.isProduction() && 'serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('PrawnHub SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('PrawnHub SW registration failed: ', registrationError);
          });
      });
    }
    */
  }, []);
};

// Image optimization helper
export const optimizeImage = (src, alt, className, onClick, title) => {
  return {
    src,
    alt: alt || "PrawnHub Interactive Content",
    className,
    onClick,
    title: title || alt,
    loading: "lazy",
    decoding: "async",
    onError: (e) => {
      console.log('Image load error:', src);
      e.target.style.display = 'none';
    }
  };
};

// Meta tag optimization for different app states
export const getStateSpecificMeta = (appState) => {
  const metaTags = {
    intro: {
      title: "PrawnHub by Labby Labs",
      description: "This is a prawn website.",
      keywords: "prawnhub, prawn website, labby labs, satirical art, interactive experience, prawn simulator"
    },
    vibe: {
      title: "PrawnHub by Labby Labs - Vibe Simulator",
      description: "This is a prawn website. Experience the peaceful vibe simulator.",
      keywords: "prawnhub vibe simulator, prawn website, peaceful prawn experience, labby labs art"
    },
    kill: {
      title: "PrawnHub by Labby Labs - Help the Prawns Mode", 
      description: "This is a prawn website. Experience the unique Help the Prawns rescue simulator.",
      keywords: "prawnhub help the prawns, prawn rescue simulator, prawn website, action prawn experience, labby labs interactive art"
    },
  };
  
  return metaTags[appState] || metaTags.intro;
};
